import { render, staticRenderFns } from "./MeetingCorrespondence.vue?vue&type=template&id=399e6ec1&"
import script from "./MeetingCorrespondence.vue?vue&type=script&lang=js&"
export * from "./MeetingCorrespondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports